import {Component, OnDestroy, OnInit} from '@angular/core';
import {MessageModel} from '../../../shared/models/message.model';
import {SensorsiteModel} from '../../../shared/models/sensorsite.model';
import {SensorModel} from '../../../shared/models/sensor.model';
import {Subscription} from 'rxjs/Subscription';
import {MasterService} from '../../../shared/services/master.service';
import {SensorsService} from '../../../shared/services/sensors.service';
import {DataService} from '../../../shared/services/data.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Location} from '@angular/common';
import {SiteModel} from '../../../shared/models/site.model';
import { SitesService } from '../../../shared/services/sites.service';
import { ServersService } from '../../../shared/services/servers.service';
import { ServerModel } from '../../../shared/models/server.model';
import { any } from 'underscore';

@Component({
  selector: 'ngx-sensors-sites',
  templateUrl: './sensors-sites.component.html',
  styleUrls: ['./sensors-sites.component.scss'],
})
export class SensorsSitesComponent implements OnInit, OnDestroy {

  message: MessageModel;

  sites: Array<SensorsiteModel> = [];
  servers: ServerModel[];
  doShowId: boolean = false;
  sensorId: number;
  subscription: Subscription;
  subscription1: Subscription;
  subscription2: Subscription;
  isLoaded: boolean = false;

  diffServer: number[]= [];
  sensor: SensorModel;
  site: SiteModel;
  siteArr: SiteModel[] = [];
  sensorServer: string;
  constructor(
    private masterService: MasterService,
    private sensorService: SensorsService,
    private dataService: DataService,
    private siteService: SitesService,
    private serversService: ServersService,
    private location: Location,
    private router: Router,
    private modalService: NgbModal,
  ) {
  }

  ngOnInit() {

    this.configureUI();

  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // Private methods

  configureUI() {
    if (this.dataService.selectedSensor != null) {
      this.sensorId = this.dataService.selectedSensor.id;
    //  console.log('sensorID::::', this.sensorId);
      this.subscription = this.sensorService.getSensor(this.sensorId).subscribe(
        (sensor) => {
          this.sensor = sensor;
          this.sites = sensor.sites;
          this.dataService.selectedSensor = sensor;
          this.sensorServer = sensor.serverName;

          this.subscription1 = this.siteService.getSensorSites(this.sites).subscribe(
            (site: SiteModel[]) => {
            //  console.log('Sensor sites[]..', site);
             this.siteArr = site;
            //  console.log('Sensor siteArr[]..', this.siteArr);
             this.siteArr.forEach(element => {
              this.serversService.getServers().subscribe((servers: ServerModel[]) => {
                this.servers = servers;
                for (const server of this.servers){
                  if (server.id === element.serverId) {
                    element.serverName = server.name;
                 //  console.log('server name ', element.serverName);
                  }
                }
              });
               if (element.serverId !== this.sensor.serverId) {
                // console.log('diff server', element.serverId);

                //  this.serversService.getServers().subscribe((servers: ServerModel[]) => {
                //    this.servers = servers;
                //    for (const server of this.servers){
                //      if (server.id === element.serverId) {
                //        element.serverName = server.name;
                //       console.log('server name ', element.serverName);
                //      }
                //    }
                //  });
                 this.diffServer.push(element.id);
               }
             });
             },
           );
          this.isLoaded = true;
        },

        error => {
          console.log(error);
          window.alert('Error: ' + error.message + ', error status: ' + error.status);
        });
    } else {
      // console.log('sensor is empty');
    }
  }

  serverName(key: string) {
    const server = this.servers.find(el => el.id === +key);
    return server.name.length > 16 ? server.name.slice(0, 15) + '...' : server.name;
  }

  // checkServer(siteServer: string, sensorServer: string ): boolean {
  //   if (siteServer !== sensorServer) {
  //     return this.diffServer = false;
  //   } else {
  //     return this.diffServer = true;
  //   }
  // }


  changeColor(siteId: number): any {
    for (let i = 0; i < this.diffServer.length; i++) {
      const element = this.diffServer[i];
      if (this.diffServer[i] === siteId) {
      //  console.log('change color..');
        return { 'color': '#ff1818'};
      }
    }
  }
  associateToSite() {
    // this.router.navigate(['/pages/regionAssociation']);
    // const activeModal = this.modalService.open(VirtualRegionComponent,
    //   {size: 'lg', container: 'nb-layout', backdrop: 'static'});
    //
    // activeModal.result.then((region?: any) => {
    //   if (region != null) {
    //     this.regions.push(region);
    //   }
    // })
    this.router.navigate(['/pages/sensors/associate']);

  }

  disassociateSensorFromSite(site) {
   // console.log('disassociate site ID ', site.id);

    this.sensorService.disassociateSensor(
      this.sensorId,
      site.id,
    )
      .subscribe(
        (report: any) => {
          window.alert('Sensor ' + this.sensorId + ' was successfully disassociated.');
          this.sites = this.sites.filter(
            filtersite => filtersite.siteId !== site.id);

        },
        error => {
          console.log(error);
          window.alert('Error: ' + error.message + ', error status: ' + error.status);
        });
        this.isLoaded = true;
  }

  private showMessage(text: string, type: string = 'danger') {
    this.message = new MessageModel(type, text);
    window.setTimeout(() => {
      this.message.message = '';
      this.message.status = '';
    }, 5000);
  }

  onUserSelectRow(event): void {
    // console.log('onUserSelect Site: ', event.id);
      if (this.siteArr !== null) {
        this.siteArr.forEach(element => {
          if (element.id === event.id) {
            this.dataService.selectedSite = element;
            this.router.navigate(['pages/sites/site', this.dataService.selectedSite.id]);
          }
        });
      }

}

}
